import slider from "./slider";

export default function () {
  const el = document.querySelector(".js-words-slider");

  if (!el) return;

  const elements = {
    slides: document.querySelectorAll(".js-words-slider-slide"),
    container: document.querySelector(".js-words-slider-container"),
  };

  const word_slider = new slider(elements);

  slider.separateWordsInLetters(el.querySelectorAll(".js-word"));

  elements.container.addEventListener("mouseenter", () =>
    word_slider.hover(true)
  );
  elements.container.addEventListener("mouseleave", () =>
    word_slider.hover(false)
  );

  word_slider.start();
}
